module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "errModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default create-account",
    attrs: {
      "id": "refuse",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            REFUSER\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "approve",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            J'AI LU ET ACCEPTE LES CONDITIONS D'UTILISATION DU SITE   \n            "), _c('svg', {
    staticStyle: {
      "fill": "var(--secondary-color)",
      "width": "20px",
      "height": "14px"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "4828 932 20 14.579"
    }
  }, [_c('path', {
    staticClass: "a",
    attrs: {
      "d": "M24.476,11.776a.388.388,0,0,0-.274.114L10.857,25.237l-5.065-4.58a.39.39,0,0,0-.547.011l-.134.139a.382.382,0,0,0,.011.547l5.422,4.9a.4.4,0,0,0,.343.093.38.38,0,0,0,.33-.1L24.886,12.574a.386.386,0,0,0,0-.547l-.137-.137A.386.386,0,0,0,24.476,11.776Z",
      "transform": "translate(4823 920.224)"
    }
  })])])])])])]), _vm._v(" "), _c('app-header'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "visibility": "hidden",
      "position": "absolute",
      "top": "-10000px"
    },
    attrs: {
      "id": "showModalButton",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#errModal"
    }
  }, [_vm._v("\n    Launch modal\n  ")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "authentMe"
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('svg', {
    staticClass: "info-box-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "8949 -947 14.89 50"
    }
  }, [_c('path', {
    staticClass: "a",
    attrs: {
      "d": "M30.19,997.365a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,30.19,997.365Zm0,16.541H22.56l.012,3,5.89-.021v27.5H22.556l.006,2.952,7.628.01,7.255.018-.006-2.97-5.519-.01v-27.5c0-2.991.046-2.987-1.73-2.987Z",
      "transform": "translate(8926.444 -1944.365)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-text"
  }, [_vm._v("\n        Merci d’entrer votre identifiant et mot de passe Orisha Commerce pour vous connecter.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "error-box"
  }, [_vm._m(2), _vm._v(" "), _c('svg', {
    staticClass: "error-box-icon",
    staticStyle: {
      "fill": "var(--error-primary-color)"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "3179.1 1494.105 25.995 26"
    }
  }, [_c('path', {
    staticClass: "a",
    attrs: {
      "d": "M30.316,5c.525.13.972.906.416,1.282L19.124,17.891c3.953,3.953,8.35,8.519,11.823,12.081.285.663-.794,1.416-1.236.761L18.1,19.124c-3.913,3.913-8.519,8.349-12.081,11.823-.663.285-1.416-.794-.761-1.236L16.871,18.1C13.233,13.842,8.521,9.586,5.047,6.023c-.285-.663.794-1.416,1.236-.761L17.89,16.871c3.858-3.858,8.5-8.306,12.024-11.791A.6.6,0,0,1,30.316,5Z",
      "transform": "translate(3174.1 1489.11)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "refuse-box"
  }, [_vm._m(3), _vm._v(" "), _c('svg', {
    staticClass: "refuse-box-icon",
    staticStyle: {
      "fill": "var(--error-primary-color)"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "3179.1 1494.105 25.995 26"
    }
  }, [_c('path', {
    staticClass: "a",
    attrs: {
      "d": "M30.316,5c.525.13.972.906.416,1.282L19.124,17.891c3.953,3.953,8.35,8.519,11.823,12.081.285.663-.794,1.416-1.236.761L18.1,19.124c-3.913,3.913-8.519,8.349-12.081,11.823-.663.285-1.416-.794-.761-1.236L16.871,18.1C13.233,13.842,8.521,9.586,5.047,6.023c-.285-.663.794-1.416,1.236-.761L17.89,16.871c3.858-3.858,8.5-8.306,12.024-11.791A.6.6,0,0,1,30.316,5Z",
      "transform": "translate(3174.1 1489.11)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_name),
      expression: "user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "user-name",
      "name": "user-name",
      "type": "text",
      "autocomplete": "username",
      "placeholder": "Identifiant utilisateur"
    },
    domProps: {
      "value": (_vm.user_name)
    },
    on: {
      "keydown": _vm.onSubmitEnter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "error-reset"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "name": "password",
      "type": "password",
      "autocomplete": "current-password",
      "placeholder": "Mot de passe"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keydown": _vm.onSubmitEnter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "error-reset"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "submitAuth",
      "name": "submitAuth"
    }
  }, [_vm._v("SE CONNECTER")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "forgotten-password",
      "href": _vm.config[_vm.env].loginUrl,
      "target": "_blank"
    }
  }, [_vm._v("J'ai oublié mon mot de passe")])])])]), _vm._v(" "), _c('button', {
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "id": "modalButton",
      "type": "button"
    }
  }, [_vm._v("\n    Launch modal\n  ")]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header conditions-utilisation"
  }, [_c('div', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("\n            CONDITIONS D’UTILISATION DU SITE\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('section', {
    attrs: {
      "id": "cgu-section"
    }
  }, [_c('div', {
    staticClass: "h3-sub-title"
  }, [_vm._v("Préambule")]), _vm._v(" "), _c('p', {
    staticClass: "col-md-12 columns"
  }, [_vm._v("Le présent site, entièrement géré par Orisha Adgency, est un site de dépôt et de mise en ligne de messages dans lʼespace dédié aux commerçants du programme Orisha Adgency. Les messages doivent être de type informatif concernant votre commerce (horaires, congés, menu du jour...) ou dʼauto-promotion (services et ou produits disponibles, promotions et soldes...). Lʼutilisation de lʼespace commerçant dans le programme Orisha Adgency est gratuite et exclusivement réservée aux clients Orisha. Cet espace ne peut être commercialisé ni cédé à un tiers. Le seul fait dʼutiliser le présent site implique lʼacceptation pleine et entière des conditions dʼutilisation décrites ci-dessous.")]), _vm._v(" "), _c('div', {
    staticClass: "h3-sub-title"
  }, [_vm._v("Contenu des messages diffusés dans l’espace commerçant")]), _vm._v(" "), _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("\n              Nous vous remercions de respecter le règlement sur le contenu décrit ci-dessous."), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Règlement sur les contenus interdits")]), _c('br'), _vm._v("\n              Afin de maintenir un service de qualité, il est interdit de diffuser un message :"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block",
      "padding-left": "15px"
    }
  }, [_vm._v("\n              - qui contient des informations personnelles concernant un individu ne souhaitant pas qu'elles apparaissent"), _c('br'), _vm._v("\n              - qui soit mensonger*, diffamatoire, profane, haineux, abusif, pornographique, obscène ou de toute autre nature inappropriée (et laissé à notre seule discrétion)"), _c('br'), _vm._v("\n              - qui encourage la violence ou toute conduite criminelle"), _c('br'), _vm._v("\n              - qui dévoile des éléments de nature privée ou viole la vie privée d'une personne (inclus la publication de visages) sans son autorisation"), _c('br'), _vm._v("\n              - qui contrevienne aux droits de propriété physique ou intellectuelle d'un tiers"), _c('br'), _vm._v("\n              - qui propose de l'information, des produits ou des services dont la vente, la distribution ou la divulgation est sujette à régulations** ou dont la possession ou vente est illégale. Vous ne pouvez diffuser un message dont le but est de vendre des objets contrefaits, de la drogue (interdite ou sur ordonnance), tout type de médicaments, des armes à feu sans permis ou armes blanches, des organes ou parties de corps humain, des billets de loterie, du tabac, de l'alcool ou tout type de produit dangereux."), _c('br'), _vm._v("\n              - faisant la promotion de groupes à caractère sectaire.")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "var(--primary-color)",
      "font-weight": "bold",
      "font-style": "italic"
    }
  }, [_vm._v("Attention :")]), _c('br'), _vm._v("\n              * Veillez à ce que les termes que vous utilisez pour communiquer à propos dʼun produit soient bien exacts. Par exemple, vous ne pouvez pas parler de carte de crédit à propos de PCS Card car il sʼagit en réalité dʼune carte de paiement, vous seriez exposé à des poursuites pour publicité mensongère."), _c('br'), _vm._v("\n              ** La Loi Evin et la loi Santé qui régissent la publicité concernant l'alcool, le tabac, l'alimentation sont très contraignantes et restrictives.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("\n              Nous rappelons que l'ensemble des agissements susvisés constituent des infractions définies et réprimées par le code pénal français, dont la violation pourrait vous engager à des poursuites ou sanctions judiciaires, l'Equipe Orisha Adgency ne pouvant être tenue responsable du contenu de vos messages. Vous êtes responsables de vous assurer de respecter la loi qui s'applique aux biens et services que vous offrez.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("\n              Cette liste est non exhaustive et Orisha Adgency se réserve le droit dʼarrêter la diffusion de tout message non conforme.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "col-md-12"
  }, [_c('em', [_c('span', {
    staticStyle: {
      "color": "var(--primary-color)",
      "font-weight": "bold"
    }
  }, [_vm._v("Information sur lʼutilisation des logos :")]), _vm._v(" Nous vous rappelons quʼil ne vous est pas possible de faire la promotion de produits en faisant figurer les logos des marques car leur utilisation est soumise à une réglementation stricte.")])]), _vm._v(" "), _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("\n              Dans le cas où un utilisateur réitère la diffusion de messages non conformes, Orisha Adgency se réserve le droit de lui interdire lʼaccès au site.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "h3-sub-title"
  }, [_vm._v("Responsabilité")]), _vm._v(" "), _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("\n              Orisha Adgency se réserve le droit d'interrompre l'accès au site pour procéder à des opérations de maintenance et/ou de test. Orisha Adgency s'efforcera de réaliser ces opérations pour les durées les plus courtes possible et en dehors des heures de forte utilisation. La responsabilité de Orisha Adgency ne pourra en aucun cas être recherchée de ce fait.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "h3-sub-title"
  }, [_vm._v("Durée de diffusion")]), _vm._v(" "), _c('p', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_vm._v("\n              Vous seul gérez la durée de diffusion de vos messages, vous pouvez les actualiser aussi souvent et aussi fréquemment que vous le souhaitez.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_vm._v("DIGITAL POINT DE VENTE - Orisha Adgency – SARL au capital de 12 000€ - RCS Paris 500 248 141"), _c('br'), _vm._v("\n              T : 01 53 09 26 80 – www.retail-shops.orisha.com/adgency")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-text"
  }, [_c('ul', [_c('li', [_vm._v("Votre identifiant ou votre mot de passe est erroné."), _c('br'), _vm._v("Merci de réessayer.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "refuse-text"
  }, [_c('ul', [_c('li', [_vm._v("Vous ne pouvez pas créer d'annonces ou de publicités si vous"), _c('br'), _vm._v("refusez les conditions générales du site.")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a4444b34", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4444b34","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 201
// module chunks = 1